// Paket Yönetimi Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.packageSettings';

export const packageSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Paket Yönetimi Ayarları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Paket sipariş ekranındaki ⚙ Ayarlar düğmesi bu pencereyi açar. Genel sekmesinde sesler, Yazdırma sekmesinde yazıcılar ayarlanır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    tabs: t(`${G}.regions.tabs`, 'Genel / Yazdırma'),
    body: t(`${G}.regions.body`, 'Ayarlar'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  navItems: [
    t(`${G}.nav.general`, 'Genel'),
    t(`${G}.nav.printing`, 'Yazdırma'),
  ],
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Genel: telefon zil sesi ve popup'),
      text: t(`${G}.s1.text`, '"Telefon Zil Sesi" açıkken telefon çalınca bilgisayardan zil sesi çalar; "Zil Sesi Seçin" ile sesi seçip "Test Et" ile dinleyin. "Gelen Arama Popup" açıkken telefon çalınca ekranda büyük bir pencere açılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Genel sekmesindeki seçimler hemen geçerli olur ve yalnız bu bilgisayarda saklanır; başka kasalardaki ayarı değiştirmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Bildirim sesini sınayın'),
      text: t(`${G}.s2.text`, '"Yeni Sipariş Sesi", Yemeksepeti, Getir, Migros, Uber Eats, QR menü ve kiosk siparişleri gelince çalan uyarı sesidir. "Sınama Sesi Çal" ile bilgisayarın sesinin çalıştığını kontrol edin; sonuç düğmenin altında yazar.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s3.title`, '3. Yazdırma: yöntem ve yazıcı'),
      text: t(`${G}.s3.text`, 'Yazdırma sekmesinde önce yöntemi seçin. "Tek Yazıcı Kullan": tüm fişler varsayılan yazıcıya gider. "Kategori Bazlı Yazıcı": her ürün kategorisine ayrı yazıcı atanır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Yerel Ağdaki Yazıcılar" listesi masaüstü yazılımı (yerel servis) çalışırken dolar; "Yerel Yazıcıları Yenile" ile güncelleyin.'),
        t(`${G}.s3.tip2`, 'Yazıcının yanındaki "Ayarla" onu varsayılan yapar, "Test" deneme sayfası basar.'),
        t(`${G}.s3.tip3`, '"Ağ Yazıcıları" bölümünden Ethernet / Wi-Fi yazıcıyı IP adresiyle ekleyebilirsiniz; sürücü kurmak gerekmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Adisyon ve fiş başlığı'),
      text: t(`${G}.s4.text`, '"Adisyon Yazdırma Ayarları" düğmesi adisyon fişinin ayarlarını açar. Kategori bazlı modda "Ana Fiş Yazıcısı" seçilirse tüm ürünleri içeren adisyon o yazıcıdan çıkar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Buradaki fiş başlığı, markaya özel başlık tanımlanmamış tüm siparişlerde kullanılır. Markaya özel başlık için Entegrasyonlar sayfasından ilgili mağazayı düzenleyin.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin ve kapatın'),
      text: t(`${G}.s5.text`, 'Yazdırma sekmesindeki değişiklikler "Yazdırma Ayarlarını Kaydet"e basınca ekrana kaydedilir. Kaydetmeden "Kapat"a basarsanız yazdırma değişiklikleri kaydedilmez. Başlıktaki (i) bu rehberi açar.'),
    },
  ],
});
